import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { SmartLockPage } from '../smart-lock/smart-lock';
import {SmartLockLogPage} from '../smart-lock-log/smart-lock-log';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-smart-lock-tabs',
  templateUrl: 'smart-lock-tabs.html',
})
export class SmartLockTabsPage {

  smartLock = SmartLockPage;
  smartLockLog = SmartLockLogPage;
  index = 0;
  constructor(public navCtrl: NavController, private translate: TranslateService, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SmartLockTabsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/smart-lock-tabs/smart-lock-tabs.ts